
import { Component, Vue } from 'vue-property-decorator'
import RegisterWrapper from '@/components/register/RegisterWrapper.vue'
import { OPEN_URL } from '@/common/variables'

@Component({
  components: {
    RegisterWrapper
  }
})
export default class CertificateSuccess extends Vue {
  get wrapperTitle() {
    switch (this.$store.state.userData.certifiedStatus) {
      case 'PENDING':
        return '审核中'
      case 'VERIFIED':
        return '认证成功'
      default:
        return '审核中'
    }
  }

  get text() {
    switch (this.$store.state.userData.certifiedStatus) {
      case 'PENDING':
        return '认证审核中'
      case 'VERIFIED':
        return '您已认证成功'
      default:
        return '认证审核中'
    }
  }

  get tips() {
    switch (this.$store.state.userData.certifiedStatus) {
      case 'PENDING':
        return '认证审核中，预计1-2个工作日完成资料审核'
      case 'VERIFIED':
        return '您已认证成功，无需重新认证'
      default:
        return '认证审核中，预计1-2个工作日完成资料审核'
    }
  }

  get buttonText() {
    switch (this.$store.state.userData.certifiedStatus) {
      case 'PENDING':
        return '我的账号'
      case 'VERIFIED':
        return '我的账号'
      default:
        return '返回'
    }
  }
  handleBack() {
    if (this.buttonText === '我的账号') {
      this.$router.push({ name: 'Home' })
    } else {
      const { redirect_url } = this.$route.query
      window.open((redirect_url as string | undefined) || OPEN_URL, '_self')
    }
  }
}
